import { EarningsScenarioResponse, Entity } from '@api';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { useState } from 'react';

import { EarningsChart } from '../earnings-chart/EarningsChart';
import { ExpectationReported } from '../expectation-reported/ExpectationReported';
import { ExpectationsSwitcher } from '../expectations-switcher/ExpectationsSwitcher';
import { Expectation } from '../types';
import styles from './EarningsWidget.module.scss';

export interface EarningsWidgetProps {
  earningsData: EarningsScenarioResponse;
  entity: Entity;
  source: PosthogTrackingSource;
}

export const EarningsWidget = ({
  earningsData,
  entity,
  source,
}: EarningsWidgetProps) => {
  const [expectation, setExpectation] = useState<Expectation>(Expectation.Beat);
  const { reported, currency, eps, reporting_date } = earningsData;

  return (
    <div className={styles.earningsWidgetRoot} data-testid="earnings-widget">
      {reported && <ExpectationReported earning={eps} currency={currency} />}

      {!reported && (
        <ExpectationsSwitcher
          expectation={expectation}
          onChange={newExpectation => setExpectation(newExpectation)}
        />
      )}

      <EarningsChart
        key={`${reporting_date}`}
        expectation={expectation}
        earningsData={earningsData}
        entity={entity}
        source={source}
      />
    </div>
  );
};
